import {
    BULK_UPDATE_ADVERT_FAIL,
    BULK_UPDATE_ADVERT_SUCCESS,
    CREATE_ADVERT_FAIL,
    CREATE_ADVERT_SUCCESS,
    GET_COE_BIDDING_LIST_FAIL,
    GET_COE_BIDDING_LIST_SUCCESS,
    DELETE_ADVERT_FAIL,
    DELETE_ADVERT_SUCCESS,
    GET_ADVERT_DETAILS_FAIL,
    GET_ADVERT_DETAILS_SUCCESS,
    GET_ADVERT_INQUIRY_LISTING_FAIL,
    GET_ADVERT_INQUIRY_LISTING_SUCCESS,
    GET_ADVERT_LISTING_FAIL,
    GET_ADVERT_LISTING_SUCCESS,
    GET_ADVERT_REMARK_LISTING_FAIL,
    GET_ADVERT_REMARK_LISTING_SUCCESS,
    GET_ERP_DETAILS_FAIL,
    GET_ERP_DETAILS_SUCCESS,
    GET_ERP_LISTING_FAIL,
    GET_ERP_LISTING_SUCCESS,
    REQUEST_MAKE_MODEL_FAIL,
    REQUEST_MAKE_MODEL_SUCCESS,
    REQUEST_SINGPASS_FAIL,
    REQUEST_SINGPASS_SUCCESS,
    RESET_ADVERT_ACTION_STATE,
    RESET_ADVERT_STATE,
    UPDATE_ADVERT_FAIL,
    UPDATE_ADVERT_SUCCESS,
    SET_ERP_DETAILS_LOCAL
} from "./actionTypes"

const INIT_STATE = {
    erpListing: [],
    erpDetails: [],
    advertListing: [],
    coeBiddingList: [],
    advertRemarkListing: [],
    advertInquiryListing: [],
    advertDetails: [],
    advertInterestRate: [],
    advertAdd: [],
    advertEdit: [],
    advertBulkEdit: [],
    advertRequestMakeModel: [],
    advertDelete: [],
    singpassRes: [],
    error: [],
}

const Advert = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ADVERT_LISTING_SUCCESS:
            return {
                ...state,
                advertListing: action.payload
            }
        case GET_ADVERT_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_ADVERT_REMARK_LISTING_SUCCESS:
            return {
                ...state,
                advertRemarkListing: action.payload
            }
        case GET_ADVERT_REMARK_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_COE_BIDDING_LIST_SUCCESS:
            return {
                ...state,
                coeBiddingList: action.payload
            }
        case GET_COE_BIDDING_LIST_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_ADVERT_INQUIRY_LISTING_SUCCESS:
            return {
                ...state,
                advertInquiryListing: action.payload
            }
        case GET_ADVERT_INQUIRY_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_ADVERT_DETAILS_SUCCESS:
            return {
                ...state,
                advertDetails: action.payload
            }
        case GET_ADVERT_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
                advertDetails: action.payload,
            }

        case GET_ERP_LISTING_SUCCESS:
            return {
                ...state,
                erpListing: action.payload
            }
        case GET_ERP_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
                erpListing: action.payload,
            }

        case GET_ERP_DETAILS_SUCCESS:
            return {
                ...state,
                erpDetails: action.payload
            }
        case GET_ERP_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case CREATE_ADVERT_SUCCESS:
            return {
                ...state,
                advertAdd: action.payload
            }
        case CREATE_ADVERT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_ADVERT_SUCCESS:
            return {
                ...state,
                advertEdit: action.payload
            }
        case UPDATE_ADVERT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case BULK_UPDATE_ADVERT_SUCCESS:
            return {
                ...state,
                advertBulkEdit: action.payload
            }
        case BULK_UPDATE_ADVERT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case REQUEST_MAKE_MODEL_SUCCESS:
            return {
                ...state,
                advertRequestMakeModel: action.payload
            }
        case REQUEST_MAKE_MODEL_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_ADVERT_SUCCESS:
            return {
                ...state,
                advertDelete: action.payload
            }
        case DELETE_ADVERT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case REQUEST_SINGPASS_SUCCESS:
            return {
                ...state,
                singpassRes: action.payload
            }
        case REQUEST_SINGPASS_FAIL:
            return {
                ...state,
                error: action.payload,
                singpassRes: action.payload,
            }

        case RESET_ADVERT_ACTION_STATE:
            return {
                ...state,
                advertAdd: [],
                advertEdit: [],
                advertBulkEdit: [],
                advertDelete: [],
                advertInterestRate: [],
                advertRequestMakeModel: [],
                singpassRes: [],
                error: [],
            }

        case SET_ERP_DETAILS_LOCAL:
            return {
                ...state,
                erpDetails: action.payload
            }

        case RESET_ADVERT_STATE:
            return {
                ...state,
                erpListing: [],
                erpDetails: [],
                advertListing: [],
                advertRemarkListing: [],
                advertInquiryListing: [],
                advertDetails: [],
                advertAdd: [],
                advertEdit: [],
                advertBulkEdit: [],
                advertDelete: [],
                advertInterestRate: [],
                singpassRes: [],
                error: [],
            }
        default:
            return state
    }
}

export default Advert
